function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".enable2Fa_svg__st0{fill:none}.enable2Fa_svg__st1{fill:#fff}.enable2Fa_svg__st2{stroke-width:2}.enable2Fa_svg__st2,.enable2Fa_svg__st3{fill-opacity:0;stroke:#7b66f6;stroke-miterlimit:10}.enable2Fa_svg__st5{opacity:.2;fill:#7b66f6;enable-background:new}.enable2Fa_svg__st10,.enable2Fa_svg__st7,.enable2Fa_svg__st9{fill-opacity:0;stroke:#7b66f6}.enable2Fa_svg__st10,.enable2Fa_svg__st9{stroke-width:2}.enable2Fa_svg__st10{display:none;stroke:#3ead4f;stroke-width:.36;stroke-miterlimit:1.44}.enable2Fa_svg__st11{fill:#7b66f6}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st0",
  d: "M0-1h150v150H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st0",
  d: "M0-1h150v150H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M105.8 41.5H5.6c-2.2 0-3.9 1.8-3.9 3.9v95.2c0 2.2 1.8 3.9 3.9 3.9h4.1l2 4h8l2-4h68l2 4h8l2-4h4.1c2.2 0 3.9-1.8 3.9-3.9V45.4c0-2.1-1.8-3.9-3.9-3.9z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st2",
  d: "M105.8 41.5H5.6c-2.2 0-3.9 1.8-3.9 3.9v95.2c0 2.2 1.8 3.9 3.9 3.9h4.1l2 4h8l2-4h68l2 4h8l2-4h4.1c2.2 0 3.9-1.8 3.9-3.9V45.4c0-2.1-1.8-3.9-3.9-3.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M104.3 139.2H7.2V46.7h97.1v92.5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st3",
  d: "M104.3 139.2H7.2V46.7h97.1v92.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M101.3 136.4H10.2V49.7h91.1v86.7z",
  fillOpacity: 0,
  stroke: "#7b66f6",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M7.1 56.6c-1.9 0-2.9.9-2.9.9v14s1 .9 2.9.9 2.9-.9 2.9-.9v-14s-1-.9-2.9-.9z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st3",
  d: "M7.1 56.6c-1.9 0-2.9.9-2.9.9v14s1 .9 2.9.9 2.9-.9 2.9-.9v-14s-1-.9-2.9-.9z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M7.1 116c-1.9 0-2.9.7-2.9.7v11.2s1 .7 2.9.7 2.9-.7 2.9-.7v-11.2s-1-.7-2.9-.7z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st3",
  d: "M7.1 116c-1.9 0-2.9.7-2.9.7v11.2s1 .7 2.9.7 2.9-.7 2.9-.7v-11.2s-1-.7-2.9-.7zM4.2 60.6H10M4.2 68.3H10M4.2 64.5H10M4.2 122H10M4.2 118.5H10M4.2 126.1H10"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st5",
  d: "M84.1 95.8l-5.4-.4c0 .4-.4.8-.9.7-.4 0-.8-.4-.7-.9l-15.5-1c-5.7-.7-8.1-6-8.5-6l-6.8-13.8c-.4.2-.9 0-1.1-.4s0-.9.4-1.1L43.2 68s-1-.2-2.3.4-1.8 1.6-1.8 1.6l2.4 4.9c.4-.2.9 0 1.1.4.2.4 0 .9-.4 1.1l6.7 13.9c1.1 1.6 2.5 3.3 2.5 5.5 0 1.9-1 2.3-3 5.1l-8.6 13c.4.2.5.7.2 1.1-.2.4-.7.5-1.1.2l-3 4.5s.3 1 1.5 1.8 2.2.7 2.2.7l3-4.5c-.4-.2-.5-.7-.2-1.1.2-.4.7-.5 1.1-.2l8.8-13.1c2.7-4.2 3-4.7 3.7-4.7.6-.1.2.1 5.1.4l15.7 1c0-.4.4-.8.9-.8.4 0 .8.4.7.9l5.4.4s.7-.8.8-2.2c.1-1.4-.5-2.5-.5-2.5z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st5",
  d: "M54.2 86.2c4.6 0 8.4 3.8 8.4 8.4s-3.8 8.4-8.4 8.4-8.4-3.8-8.4-8.4c0-4.6 3.8-8.4 8.4-8.4z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5 93.4c0-13.1 10.6-23.7 23.7-23.7s23.7 10.6 23.7 23.7-10.6 23.7-23.7 23.7-23.7-10.6-23.7-23.7z",
  fillOpacity: 0,
  stroke: "#7b66f6",
  strokeWidth: 0.5
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M84.1 93.3l-5.4-.4c0 .4-.4.8-.9.7-.4 0-.8-.4-.7-.9l-15.5-1c-.7-3.4-3.8-6-7.5-6-.4 0-.7 0-1.1.1l-6.7-13.9c-.4.2-.9 0-1.1-.4s0-.9.4-1.1l-2.4-4.9s-1-.2-2.3.4-1.8 1.6-1.8 1.6l2.4 4.9c.4-.2.9 0 1.1.4.2.4 0 .9-.4 1.1l6.7 13.9c-1.5 1.4-2.4 3.3-2.4 5.5 0 1.9.7 3.7 1.9 5l-8.6 13c.4.2.5.7.2 1.1-.2.4-.7.5-1.1.2l-3 4.5s.3 1 1.5 1.8 2.2.7 2.2.7l3-4.5c-.4-.2-.5-.7-.2-1.1.2-.4.7-.5 1.1-.2l8.8-13.1c.6.1 1.2.2 1.8.2 3.1 0 5.8-1.9 6.9-4.6l15.7 1c0-.4.4-.8.9-.8.4 0 .8.4.7.9l5.4.4s.7-.8.8-2.2-.4-2.3-.4-2.3z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M84.1 93.3l-5.4-.4c0 .4-.4.8-.9.7-.4 0-.8-.4-.7-.9l-15.5-1c-.7-3.4-3.8-6-7.5-6-.4 0-.7 0-1.1.1l-6.7-13.9c-.4.2-.9 0-1.1-.4s0-.9.4-1.1l-2.4-4.9s-1-.2-2.3.4-1.8 1.6-1.8 1.6l2.4 4.9c.4-.2.9 0 1.1.4.2.4 0 .9-.4 1.1l6.7 13.9c-1.5 1.4-2.4 3.3-2.4 5.5 0 1.9.7 3.7 1.9 5l-8.6 13c.4.2.5.7.2 1.1-.2.4-.7.5-1.1.2l-3 4.5s.3 1 1.5 1.8 2.2.7 2.2.7l3-4.5c-.4-.2-.5-.7-.2-1.1.2-.4.7-.5 1.1-.2l8.8-13.1c.6.1 1.2.2 1.8.2 3.1 0 5.8-1.9 6.9-4.6l15.7 1c0-.4.4-.8.9-.8.4 0 .8.4.7.9l5.4.4s.7-.8.8-2.2-.4-2.3-.4-2.3z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M54.2 90.1c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2-1.4-3.2-3.2-3.2z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M54.2 75.8c-9.7 0-17.5 7.8-17.5 17.5s7.8 17.5 17.5 17.5 17.5-7.8 17.5-17.5-7.8-17.5-17.5-17.5zm0 30.7c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2S67.4 86 67.4 93.3s-5.9 13.2-13.2 13.2z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M54.2 75.8c-9.7 0-17.5 7.8-17.5 17.5s7.8 17.5 17.5 17.5 17.5-7.8 17.5-17.5-7.8-17.5-17.5-17.5zm0 30.7c-7.3 0-13.2-5.9-13.2-13.2 0-7.3 5.9-13.2 13.2-13.2S67.4 86 67.4 93.3s-5.9 13.2-13.2 13.2z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M48.7 93.3c0 3.1 2.5 5.5 5.5 5.5s5.5-2.5 5.5-5.5",
  opacity: 0.2,
  fillOpacity: 0,
  stroke: "#7b66f6",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M134.6 148.1h-33.9c-3.4 0-6.1-2.7-6.1-6.1V69.4c0-3.4 2.7-6.1 6.1-6.1h33.9c3.4 0 6.1 2.7 6.1 6.1V142c0 3.4-2.7 6.1-6.1 6.1z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st2",
  d: "M134.6 148.1h-33.9c-3.4 0-6.1-2.7-6.1-6.1V69.4c0-3.4 2.7-6.1 6.1-6.1h33.9c3.4 0 6.1 2.7 6.1 6.1V142c0 3.4-2.7 6.1-6.1 6.1z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M95.5 142.4c0 2.8 2.6 5 5.9 5h32.8c3.3 0 5.9-2.2 5.9-5v-1.9H95.6l-.1 1.9z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M94.7 72h46"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st9",
  d: "M112.4 67.7h7.2M120.9 67.7h2.2"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M94.7 139.8h46M107 108.1c5.8-5.8 15.1-5.8 20.9 0 5.8 5.8 5.8 15.1 0 20.9-5.8 5.8-15.1 5.8-20.9 0s-5.8-15.1 0-20.9z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M110.3 111.3c4-4 10.5-4 14.4 0 4 4 4 10.5 0 14.4s-10.5 4-14.4 0c-4-3.9-4-10.4 0-14.4z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M114.2 115.3c1.8-1.8 4.7-1.8 6.5 0s1.8 4.7 0 6.5-4.7 1.8-6.5 0c-1.8-1.8-1.8-4.7 0-6.5z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M122.1 114l2.6-2.6-2.6 2.6z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M122.1 114l2.6-2.6"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M110.3 125.8l2.6-2.6-2.6 2.6z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M110.3 125.8l2.6-2.6"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M110.3 111.4l2.6 2.6-2.6-2.6z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M112.9 114l-2.6-2.6"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M122.1 123.1l2.6 2.6-2.6-2.6z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M124.7 125.8l-2.6-2.6"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M117.5 112.1v-3.7"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M117.5 112.1v-3.7"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M117.5 128.7V125"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M117.5 128.7V125"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M111 118.6h-3.7"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M111 118.6h-3.7"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M127.7 118.6H124"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M127.7 118.6H124"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M120 112.6l1.4-3.4"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M120 112.6l1.4-3.4"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M113.6 127.9l1.4-3.4"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M113.6 127.9l1.4-3.4"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M111.5 116l-3.4-1.4"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M111.5 116l-3.4-1.4"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M126.9 122.5l-3.4-1.4"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M126.9 122.5l-3.4-1.4"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M115.1 112.5l-1.4-3.4"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M115.1 112.5l-1.4-3.4"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M121.3 128l-1.4-3.4"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M121.3 128l-1.4-3.4"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M111.5 121l-3.4 1.4"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M111.5 121l-3.4 1.4"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st1",
  d: "M126.9 114.7l-3.4 1.4"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st7",
  d: "M126.9 114.7l-3.4 1.4"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st5",
  d: "M126.1 123.6c-1.9 3-5 4.9-8.7 4.9-3.2 0-6.1-1.5-8-3.9-.4-.5-3.9-6.2-5.1-6.2-1.7 0-1.4 3.5-.7 5.1 2.1 5.5 7.5 9.4 13.8 9.4 6.9 0 12.8-4.8 14.4-11.2.3-1.1.4-3.4-.7-3.4s-3.1 2.3-5 5.3z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st5",
  d: "M123.9 118.7c-.1 3.5-3 6.3-6.5 6.3s-6.4-2.8-6.5-6.3h-3.7c.1 5.5 4.6 10 10.2 10s10.1-4.5 10.2-10h-3.7z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st10",
  d: "M135.1 48.9s-.1.7-.1 1.7"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st11",
  d: "M107.3 89.4l-2.7-4 2.5-3.8h-1.4l-1.8 2.8-1.8-2.8h-1.5l2.5 3.8-2.7 4h1.5l1.9-3 2 3h1.5zM116.5 89.4l-2.7-4 2.5-3.8h-1.4l-1.8 2.8-1.8-2.8h-1.5l2.5 3.8-2.7 4h1.5l1.9-3 2 3h1.5zM125.8 89.4l-2.7-4 2.5-3.8h-1.4l-1.8 2.8-1.8-2.8H119l2.5 3.8-2.7 4h1.5l1.9-3 2 3h1.6zM135.1 89.4l-2.7-4 2.5-3.8h-1.4l-1.8 2.8-1.8-2.8h-1.5l2.5 3.8-2.7 4h1.5l1.9-3 2 3h1.5zM100.5 92.4h6.3v-1.5h-6.3v1.5zM110.1 92.4h6.3v-1.5h-6.3v1.5zM119 92.4h6.3v-1.5H119v1.5zM128.6 92.4h6.3v-1.5h-6.3v1.5z"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "enable2Fa_svg__st5",
  d: "M54.2 80.1C46.9 80.1 41 86 41 93.3c0 .5 0 1 .1 1.5.7-6.6 6.3-11.7 13.1-11.7s12.4 5.1 13.1 11.7c.1-.5.1-1 .1-1.5 0-7.3-5.9-13.2-13.2-13.2zM54.2 110.8c-9.2 0-16.7-7-17.4-16 0 .5-.1 1-.1 1.5 0 9.7 7.8 17.5 17.5 17.5s17.5-7.8 17.5-17.5c0-.5 0-1-.1-1.5-.7 9-8.2 16-17.4 16z"
});

function SvgEnable2Fa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "enable2Fa_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 150 150",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66);
}

export default __webpack_public_path__ + "9c5cc0bfbd2d19f402d25bd5ccea9b53.svg";
export { SvgEnable2Fa as ReactComponent };